import React from 'react'
import { Button as AntButton } from 'antd'
import {
  PlusCircleOutlined,
  DownloadOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  UploadOutlined,
  SaveOutlined,
  CloseOutlined,
} from '@ant-design/icons'
import PropTypes from 'prop-types'

const Button = ({
  children,
  type,
  size,
  icon,
  // Predefined icons as boolean props
  iconAddData,
  iconDownload,
  iconEdit,
  iconDelete,
  iconSearch,
  iconUpload,
  iconSave,
  iconClose,
  disabled,
  loading,
  danger,
  ghost,
  block,
  className,
  onClick,
  htmlType,
  style,
  ...rest
}) => {
  const getIcon = () => {
    if (icon) return icon // ถ้ามี custom icon ให้ใช้ตามที่ส่งมา
    if (iconAddData) return <PlusCircleOutlined />
    if (iconDownload) return <DownloadOutlined />
    if (iconEdit) return <EditOutlined />
    if (iconDelete) return <DeleteOutlined />
    if (iconSearch) return <SearchOutlined />
    if (iconUpload) return <UploadOutlined />
    if (iconSave) return <SaveOutlined />
    if (iconClose) return <CloseOutlined />
    return null
  }

  return (
    <AntButton
      type={type}
      size={size}
      icon={getIcon()}
      disabled={disabled}
      loading={loading}
      danger={danger}
      ghost={ghost}
      block={block}
      className={className}
      onClick={onClick}
      htmlType={htmlType}
      style={style}
      {...rest}
    >
      {children}
    </AntButton>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['primary', 'default', 'dashed', 'link', 'text']),
  size: PropTypes.oneOf(['large', 'middle', 'small']),
  icon: PropTypes.node,
  // Predefined icon props
  iconAddData: PropTypes.bool,
  iconDownload: PropTypes.bool,
  iconEdit: PropTypes.bool,
  iconDelete: PropTypes.bool,
  iconSearch: PropTypes.bool,
  iconUpload: PropTypes.bool,
  iconSave: PropTypes.bool,
  iconClose: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      delay: PropTypes.number,
    }),
  ]),
  danger: PropTypes.bool,
  ghost: PropTypes.bool,
  block: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),
  style: PropTypes.object,
}

Button.defaultProps = {
  type: 'default',
  size: 'middle',
  disabled: false,
  loading: false,
  danger: false,
  ghost: false,
  block: false,
  htmlType: 'button',
  // Default values for icon props
  iconAddData: false,
  iconDownload: false,
  iconEdit: false,
  iconDelete: false,
  iconSearch: false,
  iconUpload: false,
  iconSave: false,
  iconClose: false,
}

export default Button
